import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import HomePage from '../components/homepage/HomePage.vue'

import Register from '../components/register/register.vue'
import TeamRegister from '../components/register/teamRegister.vue'

import UseHelp from '../components/homepage/UseHelp.vue'
import Supplier from '../components/homepage/supplier.vue'
import Developers from '../components/homepage/Developers.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    }, {
      path: '/homepage',
      name: 'HomePage',
      component: HomePage
    }, {
      path: '/register',
      name: 'register',
      component: Register
    }, {
      path: '/teamRegister',
      name: 'teamRegister',
      component: TeamRegister
    }, {
      path: '/usehelp',
      component: UseHelp,
      children: [{
        path: '/supplier',
        component: Supplier
      }, {
        path: '/developers',
        component: Developers
      }]
    }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js